import { InputLabel, TextareaAutosize } from '@mui/material'
import styled from 'styled-components'
import { COLORS, TYPOGRAPHY } from 'utils'

export interface ITextAreaCustom {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  maxWidth?: string
}

export const TextareaAutosizeCustom = styled(TextareaAutosize)<ITextAreaCustom>`
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  padding: 16px;
  background: ${COLORS.white};
  border: 0.1rem solid ${COLORS.gray};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  font-size: ${TYPOGRAPHY.bodySize16};
  font-family: Arial, Helvetica, sans-serif;
  outline: 0;
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${COLORS.gray};
    line-height: 1.6rem;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${COLORS.gray};
    line-height: 1.6rem;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${COLORS.gray};
    line-height: 1.6rem;
  }
`
export const InputLabelCustom = styled(InputLabel)`
  font-size: ${TYPOGRAPHY.bodySize13};
  font-family: Arial, Helvetica, sans-serif;
  color: ${COLORS.black};
  margin: 0;
`
